import { z } from "zod";

export const zCamera = z.object({
	position: z.object({ x: z.number(), y: z.number(), z: z.number() }),
	zoom: z.number(),
	target: z.object({ x: z.number(), y: z.number(), z: z.number() }),
	type: z.enum(["perspective", "orthographic"]),
});

export type Camera = z.infer<typeof zCamera>;
